import React from 'react'
import { Divider } from 'antd'
import { Button, ButtonActionBar } from 'modules/core/components'
import { DeleteOutlined } from '@ant-design/icons'

const DeleteFormItem = ({ fieldsLength, index, onClick }) => {
  return (
    <>
      <ButtonActionBar>
        {fieldsLength > 1 && (
          <Button.LinkWhitLeftIcon
            icon={<DeleteOutlined />}
            onClick={onClick}
            title={'ACTION_DELETE'}
          />
        )}
      </ButtonActionBar>
      {fieldsLength - 1 !== parseInt(index) && <Divider />}
    </>
  )
}
export default DeleteFormItem
